import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { VenueModelResponse } from 'src/app/_models/Venue/VenueModel';
import { ApiService } from 'src/app/_services/api.service';
import { Operations } from 'src/app/_models/Operations/Operations';
import { GetHostsModelResponse } from 'src/app/_models/Host/HostModel';

@Component({
  selector: 'app-view-venue-dialog',
  templateUrl: './view-venue-dialog.component.html',
  styleUrls: ['./view-venue-dialog.component.scss']
})

export class ViewVenueDialogComponent implements OnInit {

  loading: boolean = false;
  venueId: string = '';
  list : any[];
  venueItem: VenueModelResponse | undefined
  businessTypesString: string | undefined
  public images = new Array<string>(12);
  serverImages: string[]
  selectedImageIndex: number = -1;
  showFlag: boolean = false;
  imagesObject = Array<object>();
  companyCountryCode: string;

  hostList: GetHostsModelResponse[] = [];

  constructor(
    private dialogRef: MatDialogRef<ViewVenueDialogComponent>,
    private apiService: ApiService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.venueId = data.venueId
    this.list = data.businessTypes
    this.companyCountryCode = data.companyCountryCode;
  }

  ngOnInit(): void {
    this.getVenueDetails();
  }

  private getVenueDetails() {
    this.loading = true;
    this.apiService.getVenue(this.venueId).subscribe((venue) => {
      this.venueItem = venue
      if(this.venueItem?.galeryImages !== undefined && this.venueItem?.galeryImages !== null) {
        this.serverImages = this.venueItem?.galeryImages;
        this.serverImages.forEach(image => {
          let obj: { image: string; } = { image: "" };
          obj.image = image
          this.imagesObject.push(obj)
        })
      } else {
        this.serverImages = new Array<string>(12)
      }
      let businessTypesFromObject = this.venueItem?.businessTypes.map((a: any) => a.name);
      this.businessTypesString = businessTypesFromObject.join(', ');
      this.loading = false;
      this.getHostItems();
    })
  }

  private getHostItems(){
    this.loading = true;
    this.apiService.getHostsByVenue(this.venueId).subscribe((response)=>{
      this.hostList = response;
      this.loading = false;
    });
  }

  close() {
    this.dialogRef.close(true);
  }

  showLightbox(index: number) {
    this.selectedImageIndex = index;
    this.showFlag = true;
  }

  closeImageViewer() {
    this.showFlag = false;
    this.selectedImageIndex = -1;
  }

}
